import React, { useEffect, useState } from 'react';
import {user} from './../Join/Join';
import socketIo from 'socket.io-client';
import './Chat.css';
import sendLogo from '../../images/send.png';
import Message from '../Message/Message';
import ReactScrollToBottom from 'react-scroll-to-bottom';
import closeIcon from './../../images/closeIcon.png';

// const ENDPOINT = `http://127.0.0.1:4000`
const ENDPOINT = `https://signex.herokuapp.com/`

let socket;

const Chat = () => {

            
    const [id, setid] = useState("");
    const [messages, setMessages] = useState([]);

    const send = () => {

        const message = document.getElementById('chatInput').value
        socket.emit('message', {message, id});
        document.getElementById('chatInput').value = "";
    }

    useEffect(() => {
    
        socket = socketIo(ENDPOINT, {transports: ["websocket"]});

        socket.on('connect', () => {
            // alert("Connected");
            setid(socket.id);
        });

        socket.emit('joined', {user});

        socket.on('welcome', (data) => {
            setMessages([...messages, data]);
            // console.log(data.user, data.message);
        });

        socket.on('userJoined', (data) => {
            setMessages([...messages, data]);
            // console.log(data.user, data.message);
        });

        socket.on('leave', (data) => {
            setMessages([...messages, data]);
            // console.log(data.user, data.message);
        });

        return () => {
            socket.emit('disconnect');
            socket.off();
        }
    }, []);

    useEffect(() => {
        socket.on('sendMessage', (data) => {
            setMessages([...messages, data]);
            // console.log(data.user, data.message, data.id)
        });

        socket.on('userJoined', (data) => {
            setMessages([...messages, data]);
            // console.log(data.user, data.message);
        });

        socket.on('leave', (data) => {
            setMessages([...messages, data]);
            // console.log(data.user, data.message);
        });

        return () => {
            socket.off();
        }
    }, [messages]);

    return (
        <div className="ChatPage">
            <div className="ChatContainer">
                <div className="header">
                    <h2>Signex</h2>
                    <a href="/"> <img src={closeIcon} alt="close"/> </a>

                </div>
                <ReactScrollToBottom className="chatBox">
                    {messages.map((item, i) => <Message user={item.id === id ? '': item.user} message={item.message} classs={item.id === id ? 'right': 'left'} />)}
                </ReactScrollToBottom>
                <div className="inputBox">
                    <input onKeyPress={(e)=>e.key === "Enter" ? send():null} type='text' id='chatInput' placeholder='type a message' />
                    <button onClick={send} className="sendBtn"><img src={sendLogo} alt="send"/></button>
                </div>
                
            </div>
        </div>
    )
}

export default Chat
